/**
 * 选择→修改（边界/平滑/扩展/收缩/羽化）的应用层接线。
 *
 * 选区不进历史（跟 selection-actions.ts 里其它选区动作一致），
 * 所以这里只是读当前选区、调引擎、写回 store，没有 dispatch。
 */
import { border, contract, expand, feather, smooth } from '../engine/selection/ops';
import type { SelectionModifyKind } from './actions/selection-modify-actions';
import type { AppStore } from './store';

/** amount 是像素数，向下取整到 >= 1（0 像素的修改没有意义，交给菜单置灰兜底）。 */
export function applySelectionModify(
  store: AppStore,
  kind: SelectionModifyKind,
  amount: number,
): boolean {
  const selection = store.selection;
  const document = store.document;
  if (selection === null || document === null) return false;
  const radius = Math.max(1, Math.round(amount));
  const result =
    kind === 'border'
      ? border(selection, radius)
      : kind === 'smooth'
        ? smooth(selection, radius)
        : kind === 'expand'
          ? expand(selection, radius)
          : kind === 'contract'
            ? contract(selection, radius)
            : feather(selection, radius);
  store.setSelection(result);
  return true;
}
